import  {  timeline }  from './dist/timeline';

/**
 * Timeline
 */
export const Timeline = (function () {

  let showMessages = 1;
  let showCalendar = 1;
  let showReferrals = 1;

  let mobileFilterMenuState=false;

  let init = function () {
    timeline(document.querySelectorAll('.timeline'));
    addEventListeners();
    getFilterStatus();
    initialiseMobileFilterMenu();
    setVerticalStartPosition();
    showTimeline();
  }

  /**
   * Set the status of the filter icons
   * @param string filterStatus - filter status string.
   *         e.g. "101" - Each char is 1 or 0 (on or off) for Messages,
   *          Calendar and Referrals respectively.
   */
  function setFilterStatusIcons(filterStatus) {

    showMessages  = parseInt(filterStatus.substring(0,1));
    showCalendar  = parseInt(filterStatus.substring(1,2));
    showReferrals = parseInt(filterStatus.substring(2,3));

    setFilterIcon('.timeline-settings-messages-icon', showMessages);
    setFilterIcon('.timeline-settings-calendar-icon', showCalendar);
    setFilterIcon('.timeline-settings-referrals-icon', showReferrals);

    processFilters();
  }

  /**
   * Action timeline filter and hide relevant items
   */
  function processFilters() {
    restoreFullTimeline();
    if (!showCalendar) {
      hideTimelineItems('ds_events');
    }
    if (!showMessages) {
      hideTimelineItems('ds_journal');
    }
    if (!showReferrals) {
      hideTimelineItems('ds_referrals');
    }
    // alternate timeline display setting them to left and right
    setLeftAndRight();
    // Ajax call to set the filter status
    setFilterStatus();

    setVerticalStartPosition();

  }

  /**
   * Add the listeners required for the timeline
   */
  function addEventListeners() {

    // any ajax calls will display a loading spinner
    $(document).ajaxStart(function() {
      $("#loading").show();
    });

    $(document).ajaxStop(function() {
      $("#loading").hide();
    });
    // Timeline filter status message alert has been closed manually
    $('#myds-timeline-filter-alert > .close').on('click', function(event) {
      $('#timeline-filter-alert').hide();
    });

    // Populate the timeline event modal when clicked
    $('.timeline_item').on('click', function(event) {

      // Gets the id of the timeline element clicked
      let timelineItemId = $(this).attr('data-timeline-id');
      let datasetId = $(this).attr('data-dataset');
      let timelineDiv = event.target.offsetParent;
      let dataset = $(`#myds-timeline-item-${timelineItemId}`).attr('data-type');
      let iconFilePath = $(timelineDiv).find('.timeline-icon').attr('src');
      let data = JSON.stringify({
        "timeline_dataset_id": datasetId,
        "dataset" : dataset
      });
      let showDescription = $(this).attr('data-showdescription');

      // get the timeline data via ajax call
      getTimelineData('/timeline-read-item', data, iconFilePath, showDescription);

    })

    // Set the listener for the filter status in the calendar icon
    $('.timeline-settings-calendar-icon').on('click', function(event) {
      showCalendar = !showCalendar;
      showCalendar ? $(this).removeClass('timeline-filter-icon-dimmed') : $(this).addClass('timeline-filter-icon-dimmed');
      filter();
    });
    // Set the listener for the filter status in the referrals icon
    $('.timeline-settings-referrals-icon').on('click', function(event) {
      showReferrals = !showReferrals;
      showReferrals ? $(this).removeClass('timeline-filter-icon-dimmed') : $(this).addClass('timeline-filter-icon-dimmed');
      filter();
    });
    // Set the listener for the filter status in the messages icon
    $('.timeline-settings-messages-icon').on('click', function(event) {
      showMessages = !showMessages;
      showMessages ? $(this).removeClass('timeline-filter-icon-dimmed') : $(this).addClass('timeline-filter-icon-dimmed');
      filter();
    });

  }

  function filter() {
    // Show text message that filter settings have been saved
    Util.toggleAlert('#myds-timeline-filter-alert', 'You filter preferences have been saved.', 'alert-success',2000);
    processFilters();
  }

  /**
   * Ajax call to get the current filter status.
   * On success set the filter status icons.
   */
  function getFilterStatus() {
    let data = JSON.stringify({
      "instance": '0'
    });
    let promise = ajaxCall('/timeline-read-filter-status', data);

    promise.done(function(response) {
      if (response) {
        setFilterStatusIcons(response.data);
      }
    });

    promise.fail(function(error) {
      Util.toggleAlert('#timeline-alert', "Error: Unable to get filter status", 'alert-warning', -1);
    });

  }

  /**
   * The timeline is initially hidden until the sort is done.
   * This function displays the timeline.
   */
  function showTimeline() {
    $('.timeline').removeClass('d-none');
  }


  /**
   * Ajax call to set the filter status (saved to ds_connection_variables)
   */
  function setFilterStatus() {

    // assemble the status string depending on the values of filterStatus
    let filterStatus =
      (showMessages ? "1" : "0") +
      (showCalendar ? "1" : "0") +
      (showReferrals ? "1" : "0");

    let data = JSON.stringify({
      "var_value" : filterStatus
    });

    ajaxCall('/timeline-write-filter-status', data).done(function(response) {
      return response.success === 1 ? true : false;
    }).fail(function(error) {
      Util.toggleAlert('#timeline-alert', "Error: Unable to set filter status", 'alert-warning', -1);
      return false;
    });

  }

  /**
   * Get timeline data
   * @param {string} url endpoint to request the data
   * @param {*} data data to be sent to the server
   * @param {*} iconPath path of file where icon is
   */
  let getTimelineData = function(url, data, iconPath, showDescription = false) {
    let promise = ajaxCall(url, data);

    promise.done(function(response) {
      if (response) {
        loadModalData(response.data, iconPath, showDescription);
      }
    });

    promise.fail(function(error) {
      Util.toggleAlert('#timeline-alert', "Error: Unable to get data for the timeline", 'alert-warning', -1);
    });

  }

  // click listener for toggling mobile filter status menu
  function initialiseMobileFilterMenu() {
    $('.toggle-mobile-menu').on('click', toggleMobileMenu);
  }

  // toggle mobile filter status menu
  function toggleMobileMenu() {

    if (!mobileFilterMenuState) {
      document.getElementById('mobile-menu-items').style.transform='scaleX(-1)';
      $("#myds-settings-icon").hide();
      mobileFilterMenuState=true;
    }
    else {
      document.getElementById('mobile-menu-items').style.transform='scaleX(0)';
      $("#myds-settings-icon").show();
      mobileFilterMenuState=false;
    }
  }

  return {
    init: init
  }

}());

/**
 * Post ajax call to query for data
 * @param {string} endpoint string containing the URL to which the request is sent.
 * @param {*} data data to be sent to the server.
 * @returns Deferred object response
 */
let ajaxCall = function(endpoint, data) {
  let csrf = Util.getCSRF();

  return $.ajax({
    url: endpoint,
    type: 'POST',
    data: data,
    headers: {
      'x-csrf-token': csrf
    },
    dataType: "json",
    contentType: "application/json",
    timeout: 10000,  // set timeout to 10 seconds
  });
}

/**
 * If auto_scroll_to_next_item is set as a parameter in the consuming app (e.g. auto_scroll_to_next_item: 1)
 * then scroll the timeline to the item with next timestamp after the current timestamp
 */
function setVerticalStartPosition() {

  let autoScrollToNextItem = 0;
  let element = $('.timeline');

  if (element) {
    autoScrollToNextItem = parseInt(element.attr("data-auto-scroll-to-next-item"));
  }

  if (autoScrollToNextItem) {
    let currentTimestamp = Math.floor(Date.now() / 1000);
    let items = $('.timeline__item').not('.d-none');
    let targetId = 0;

    items.each(function(index) {
      let dataTimestamp = $(this).attr('data-timestamp');

      if (dataTimestamp >= currentTimestamp) {
        targetId = dataTimestamp;
        return false;   // break;
      }
    });

    // if no timestamp found >= current time then scroll to the bottom of the page
    if (targetId == 0) {
      targetId = 'scroll-bottom';
    }

    $('html, body').animate( {
      scrollTop: ($('#' + targetId).first().offset().top)-50
    }, 500);

  }
}

/**
 * Set filter icon to dimmed or not dimmed
 *
 * @param {string} iconPath id of the icon
 * @param {integer} value - 1 - active (not dimmed), 0 - not active (dimmed)
 */
function setFilterIcon(iconPath, value) {
  value ? $(iconPath).removeClass('timeline-filter-icon-dimmed') :
    $(iconPath).addClass('timeline-filter-icon-dimmed');
}

/**
 * Hide specific timeline items - specified by dataset (e.g. 'ds_events')
 * @param {string} dataset the name of the dataset
 */
  function hideTimelineItems(dataset) {
  $("[id^=myds-timeline-item-][data-type='" + dataset + "']").addClass('d-none');
}

//  redisplay all timeline items
function restoreFullTimeline() {
  $("[id^=myds-timeline-item-]").removeClass('d-none');
}


/**
 * Traverse through all the timeline items that are to be shown
 * and alternate setting them to left and right.
 */
function setLeftAndRight() {
  let left = true;

  $("[id^=myds-timeline-item-]").each(function(e) {
    $(this).removeClass('timeline__item--left');
    $(this).removeClass('timeline__item--right');

    if (!$(this).hasClass('d-none')) {
      if (left) {
        $(this).addClass('timeline__item--left');
      } else {
        $(this).addClass('timeline__item--right');
      }
      left = !left;
    }
  });
}

function loadModalData(result, iconFilePath, showDescription) {
  let modalName = '';
  // Load the relevant modal with data.
  switch (result.dataset) {

    case 'ds_events':
      $('.modal-title').html(
        '<img src="' + iconFilePath + '" class="timeline-calendar-icon dimension-40 mr-2">' + result.title);
      $('.start-time').text("Start: " + formatTimestamp(result.start_timestamp));
      $('.end-time').text("End: " + formatTimestamp(result.end_timestamp));
      $('.duration-of-event').text("Duration: " + result.duration_string);
      $('.organiser').text("Organised by: " + result.organiser);
      $('.location').text("Location: " + result.location);
      $('.status').text("Status: " + result.status);
      $('.modal-description').text(result.description);
      break;

    case 'ds_journal':
      $('.modal-title').html(
        '<img src="' + iconFilePath + '" class="timeline-calendar-icon dimension-40 mr-2">' + result.title);
      if (result.updated_timestamp != 0 && result.created_timestamp != result.updated_timestamp) {
        $('.updated-timestamp').text("Updated: " + formatTimestamp((result.updated_timestamp)));
      }
      $('.journal-by').text("From: " + result.journal_by);
      $('.journal-to').text("To: " + result.journal_to);
      $('.journal-time-sent').text("Time Sent: " + formatTimestamp(result.journal_time_sent));
      if (result.journal_time_received != 0) {
        $('.journal-time-received').text("Time Received: " + formatTimestamp((result.journal_time_received)));
      }
      $('.journal-service-id').text("Service Id: " + result.service_id);
      $('.journal-service-name').text("Service Name: " + result.service_name);
      $('.journal-type').text("Type: " + result.type);
      $('.modal-description').text(result.journal_content);
      break;

    case 'ds_referrals':
      $('.modal-title').html(
        '<img src="' + iconFilePath + '" class="timeline-calendar-icon dimension-40 mr-2">' + result.service_name);
      $('.start-time').text("Created: " + formatTimestamp(result.start_time));
      $('.referral-status').text("Status: " + result.status);
      $('.service-url').html("Service URL: <a target='_blank' rel='noopener noreferrer' href='" +
        result.service_url + "'>" + result.service_url + "</a>");
      $('.service-email').html("Service Email: <a href='mailto:" + result.service_email + "'>" +
        result.service_email + "</a>");
      $('.contact-name').text("Contact Name: " + result.contact_name);
      $('.contact-title').text("Contact Title: " + result.contact_title);
      $('.contact-number').text("Contact Number: " + result.contact_number);
      $('.referrer-name').text("Referrer Name: " + result.referrer_name);
      $('.modal-description').text(result.service_description);
      break;

    default:
      break;

    }

    if (showDescription) {
      $("#description_timeline-modal").modal();
    } else {
      modalName = result.dataset.split('_')[1];
      $(`#myds-timeline-${modalName}-modal`).modal();
    }
  }

/**
 * Format a timestamp into readable date/time string
 *
 * @param {string} timeStamp unixtimestamp value to be formatted
 * @returns Formatted date/time string - E.g. '21st December 2022, 2:46 pm'
 */
function formatTimestamp(timeStamp) {

  if (timeStamp == 0) {
    return "";
  }

  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  let date = new Date(timeStamp * 1000);
  let formatDate = getDayAndSuffix(date.getDate()) + " " + monthNames[date.getMonth()] +
    " " + date.getFullYear();

  formatDate += ", " + formatAMPM(date);

  return formatDate;

}

/**
 * Adds suffix to the end of the day string
 * @param {integer} day - day
 * @returns - string - day and day suffix (e.g. 21st)
 */
function getDayAndSuffix(day) {
  if (day > 3 && day < 21) {
    return day + 'th';
  }

  switch (day % 10) {
    case 1:  return day + "st";
    case 2:  return day + "nd";
    case 3:  return day + "rd";
    default: return day + "th";
  }
}

/**
 * Formats 12 hour time string.
 *
 * @param {object} date - date to be formatted
 * @returns formatted 12 hour time string (e.g. '2:46 pm')
 */
function formatAMPM(date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? 'pm' : 'am';

  hours = hours % 12;
  hours = hours ? hours : 12;   // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes;

  return hours + ':' + minutes + ' ' + ampm;
}
